<template>
  <div class="card">
    <div class="card-image">
      <router-link :to="{ path: `/crafts/${craft.id}` }">
        <figure class="image is-4by3">
          <img :src="craft.attributes.cover_image" alt="Placeholder image" />
        </figure>
      </router-link>
    </div>
    <div class="card-content">
      <div class="content">
        <div class="columns">
          <div class="column is-10">
            <router-link :to="{ path: `/crafts/${craft.id}` }">
              <span class="is-size-6 ellipsis has-text-dark-primary">{{
                craft.attributes.name
              }}</span>
            </router-link>

            <span v-if="craft.attributes.steps_count > 1" class="ellipsis is-size-7"
              >{{ craft.attributes.steps_count }} Steps</span
            >
            <span v-if="craft.attributes.steps_count == 1" class="ellipsis is-size-7"
              >{{ craft.attributes.steps_count }} Step</span
            >
            <span v-else class="ellipsis is-size-7">No Step</span>

            <b-tooltip
              append-to-body
              type="is-gray"
              :label="`Last update ${dateFromNow(craft.attributes.updated_at)}`"
            >
              <small class="is-italic has-text-gray">
                <b-icon size="is-small" icon="update"></b-icon>
                <time datetime="2016-1-1">{{
                  formatDate(craft.attributes.created_at)
                }}</time>
              </small>
            </b-tooltip>
          </div>

          <div class="column is-narrow">
            <b-tooltip position="is-left" :label="category.attributes.name">
              <b-icon :icon="craftPurchaseGetIconName(category.id)"></b-icon>
            </b-tooltip>
            <br />
            <b-tooltip v-if="craft.attributes.video" position="is-left" label="Video">
              <b-icon icon="youtube"></b-icon>
            </b-tooltip>
          </div>
        </div>
        <b-progress
          type="is-success"
          :value="craft.attributes.progress * 10"
        ></b-progress>
      </div>
      <div v-if="owner" class="has-text-centered">
        <b-icon icon="menu"></b-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { dateMixin } from '@/mixins/dateMixin'
import * as moment from 'moment'
import { craftPurchaseCategoryMixin } from '@/mixins/craftPurchaseCategoryMixin'

export default {
  props: ['craft', 'owner'],
  mixins: [dateMixin, craftPurchaseCategoryMixin],
  methods: {
    formatDate (date) {
      return moment(date).format('LL')
    }
  },
  computed: {
    category () {
      return this.craft.attributes.craft_purchase_category.data
    }
  }
}
</script>
